module.exports = __webpack_public_path__ + "0e5fa4f2884ac7361c0fa942e374c73a.svg";